import { render, staticRenderFns } from "./vincularProducto.vue?vue&type=template&id=ccf82900&"
import script from "./vincularProducto.vue?vue&type=script&lang=js&"
export * from "./vincularProducto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports